import "./App.css"
import React, { useEffect, useState } from "react"
import { IonIcon } from '@ionic/react';
import { callOutline } from 'ionicons/icons';
import { mailOutline, locationOutline } from 'ionicons/icons';
import "./Contact.css"
import { db } from "./Firebase"
import { addDoc, collection, serverTimestamp } from "firebase/firestore"
export default function Contact() {
    const [submit, setSubmit] = useState(false)

    const [quoteData, setQuoteData] = useState({
        name: "",
        email: "",
        number: "",
        subject: '',
        message: '',
        read: false
    })

    const clientCollectionRef = collection(db, "messages")

    const handleChange = (event) => {
        const { name, value } = event.target
        setQuoteData(prevData => ({
            ...prevData,
            [name]: value
        }))

    }

    const handleSubmit = async (event) => {
        try {
            event.preventDefault()
            await addDoc(clientCollectionRef, { fullname: quoteData.name, email: quoteData.email, number: quoteData.number, subject: quoteData.subject, details: quoteData.message, read: quoteData.read, createdAt: serverTimestamp() })

            setSubmit(true)
            setQuoteData({
                name: "",
                email: "",
                number: "",
                subject: '',
                message: ''
            })

        } catch (error) {
            alert(error.code)
        }


    }
useEffect(()=>{
const interval=setInterval(()=>{
   
    setSubmit(false)
},5000)

return ()=>{clearInterval(interval)}
    },[])




    return (

        <div className="contact" id="contact">
            <h1>CONTACT US</h1>
            <br />
            <div className="contactcontanner" id="contactcontanner">
                <div id="toast" className={submit ? "show" : ""}> <i class="fa-solid fa-check"></i> Submission Successful!</div>:<></>

                <div className="contanner reveal">
                    <div className="heading">
                        <div className="icon"><IonIcon icon={locationOutline} className="contact-us-icons" /></div>
                        <div className="info">
                            <p>Address : </p>
                            <p id="contactinfo">Thika Rd,Ruiru, Nairobi 43375-00100.
                            </p>
                        </div>
                    </div>

                    <div className="heading">
                        <div className="icon"><IonIcon icon={callOutline} className="contact-us-icons" /></div>
                        <div className="info">
                            <p>Phone : </p>
                            <p id="contactinfo">(+254) 710 211 111</p>
                            <p id="contactinfo">(+254) 711 886 666</p>

                        </div>
                    </div>

                    <div className="heading">
                        <div className="icon"><IonIcon icon={mailOutline} className="contact-us-icons" /></div>
                        <div className="info">
                            <p>Email : </p>
                            <p id="contactinfo"><span id="email">morarahomefurniture@gmail.com</span> </p>
                        </div>
                    </div>
                </div>

                <div className="messageform " id="messageform">
                    <div className="form">
                        <form>
                            <div className="form-form" action="" method="POST" id="message-subform">

                                <input type="text" name="name" placeholder="NAME" required onChange={handleChange}  value={quoteData.name}/>

                                <input type="email" name="email" placeholder="EMAIL" required onChange={handleChange} value={quoteData.email}/>

                                <input type="number" name="number" placeholder="PHONE NUMBER" required onChange={handleChange} value={quoteData.number}/>


                                <input type="text" name="subject" placeholder="SUBJECT" required onChange={handleChange} value={quoteData.subject}/>
                                <textarea type="message" name="message" id="inputbox" cols="30" rows="5" placeholder="MESSAGE" required onChange={handleChange}></textarea>
                                <button type="submit" onClick={handleSubmit}>SEND MESSAGE</button>
                            </div>
                        </form>
                    </div>

                </div>

            </div>
        </div>


    )
}